export function isDev() {
    return process.env.NODE_ENV === 'development';
}

export function isProd() {
    return process.env.NODE_ENV === 'production';
}

export function isTest() {
    return process.env.NODE_ENV === 'test';
}

export function isLoadUserDataFromEnvEnabled() {
    return process.env.REACT_APP_USER_LOAD_FROM_ENV === 'true';
}

export function isLoadUserDataFromQueryParamsEnabled() {
    return process.env.REACT_APP_USER_LOAD_FROM_QUERY_PARAMS === 'true';
}

export function isLoadUserDataFromLocalStorageEnabled() {
    return process.env.REACT_APP_USER_LOAD_FROM_LOCAL_STORAGE === 'true';
}

export function showStudyHistory() {
    return process.env.REACT_APP_PDASH_SHOW_STUDY_HISTORY === 'true';
}

export function shouldLoadBaseUrlFromLocalStorage() {
    return process.env.REACT_APP_BASE_URL_LOAD_FROM_LOCAL_STORAGE === 'true';
}

// TODO: Remove this when the Calendar View adherence_report API is working properly with a good performance:
export function shouldRefetchSessionsOnDateChangeInCalendarView() {
    return process.env.REACT_APP_RDASH_REFETCH_SESSIONS_ON_DATE_CHANGE_IN_CALENDAR_VIEW === 'true';
}

export function isChatEnabled() {
    return process.env.REACT_APP_LOCAL_CHAT_ENABLED === 'true';
}

export function shouldShowRDashStudyStats() {
    // return true;
    return process.env.REACT_APP_RDASH_SHOW_STUDY_STATS === 'true';
}

export function isSensorDataVisualizationsEnabled() {
    return process.env.REACT_APP_SENSOR_DATA_VISUALIZATIONS_ENABLED === 'true';
}

export function isEdenEConsentEnabled() {
    return process.env.REACT_APP_RDASH_EDEN_E_CONSENT_ENABLED === 'true';
}

export function isOnPremiseInstance() {
    return process.env.REACT_APP_IS_ON_PREMISE_INSTANCE === 'true';
}

export function getEnvironmentName() {
    return process.env.REACT_APP_ENVIRONMENT_NAME;
}

export function getCaseWesternStudyId() {
    return process.env.REACT_APP_CASE_WESTERN_STUDY_ID;
}

export function getCaseWesternInterviewTrackingSurveyId() {
    return process.env.REACT_APP_CASE_WESTERN_INTERVIEW_TRACKING_SURVEY_ID;
}

export function getACTMaternityStudyId() {
    return process.env.REACT_APP_ACT_MATERNITY_STUDY_ID;
}

export function getACTMaternityDefaultPassword() {
    return process.env.REACT_APP_ACT_MATERNITY_DEFAULT_PASSWORD;
}

// Temporary workaround to fetch and verify staging CI/CD environment variables in the app.
// This checks if the ENV variables are accurately reflected post-deployment.
export function getStagingEnvironmentDeploymentTag() {
    return process.env.REACT_APP_ENVIRONMENT_DEPLOYMENT_TAG || 'not_set';
}

export function getAnonymousParticipantId() {
    return process.env.REACT_APP_ANONYMOUS_PARTICIPANT_ID;
}
/**
 * Builds a URL into the web-application (new pdash).
 * - Local: REACT_APP_WEB_APPLICATION_BASE_URL is set to web-application's origin (a different port),
 *   producing an absolute cross-origin URL.
 * - Staging/prod: the variable is unset, so this returns a relative same-domain path and the
 *   gateway routes it to web-application.
 */
export function getWebApplicationURL(path: string) {
    return `${process.env.REACT_APP_WEB_APPLICATION_BASE_URL || ''}${path}`;
}

export function getAllowedChatEmbedOrigins(): Array<string> {
    return (process.env.REACT_APP_ALLOWED_CHAT_EMBED_ORIGINS || '')
        .split(',')
        .map((o) => o.trim())
        .filter(Boolean);
}
